document.addEventListener("DOMContentLoaded", function() {
    const productDesc = document.querySelector(".product__description");
    if (!productDesc) return; 
    
    const headers = productDesc.querySelectorAll("h2");
    const contents = productDesc.querySelectorAll("p");

    // Create tab buttons
    const tabContainer = document.createElement("div");
    tabContainer.className = "tab";
    productDesc.parentNode.insertBefore(tabContainer, productDesc);

    headers.forEach((header, index) => {
        const tabButton = document.createElement("button");
        tabButton.id = "jcTab" + index;
        tabButton.textContent = header.textContent;
        tabButton.className = "tablinks";
        tabButton.addEventListener("click", function() {
            openTab(index);
        });
        tabContainer.appendChild(tabButton);

        // Initially hide content
        header.style.display = "none";
        header.nextElementSibling.classList.add("tabHide");
        header.nextElementSibling.id = "jcTabContent" + index;
    });

    // Function to handle tab switching
    function openTab(index) {
        const tabButtons = document.querySelectorAll(".tab button");
        for (i=0;i<tabButtons.length; i++) {
          var tab = document.getElementById("jcTab" + i);
          var content = document.getElementById("jcTabContent" + i);
          if (i == index) {
            tab.classList.add("active");
            content.style.display = "block";
          } else {
            tab.classList.remove("active");
            content.style.display = "none";
          }
        }
    }

    // Activate the first tab by default
    if (headers.length > 0) {
        openTab(0);
    }
});
